import { render, staticRenderFns } from "./program-form-page.vue?vue&type=template&id=b8037a68&scoped=true&"
import script from "./program-form-page.vue?vue&type=script&lang=js&"
export * from "./program-form-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8037a68",
  null
  
)

export default component.exports